import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, timeout } from 'rxjs/operators';
// import 'rxjs/add/operator/map';
import { Usuario } from '../../models/usuario.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CamaraService {

  videoNode;
  stream;
  token: string;
  usuario: Usuario;

  constructor(
    public http: HttpClient
  ) {

  }


  abrirCamara(){
    
    navigator.mediaDevices.enumerateDevices().then(devices => {
      let device = devices.find(d => d.kind == 'videoinput' && d.label.includes('back'));
      let deviceId = '';
      if(!device){
        device = devices.find(d => d.kind == 'videoinput');
      }
      deviceId = device.deviceId;
      let constraints = {
        audio: false,
        video: {
          width: 400, 
          height: 300,
          deviceId: {
            exact: deviceId
          }
        }
      }
      navigator.mediaDevices.getUserMedia(constraints).then(stream => {
        this.videoNode = document.getElementById('player');
        this.videoNode.srcObject = stream;
        this.stream = stream;
    });

    })
  }

  cerrarCamara(){
    this.videoNode.pause();

    if(this.stream){
        this.stream.getTracks()[0].stop();
    }
  }

  tomarFoto(){

    let canvas = document.createElement('canvas');

    canvas.setAttribute('width', '300');
    canvas.setAttribute('height', '300');

    let context = canvas.getContext('2d');

    context.drawImage(this.videoNode, 0, 0, canvas.width, canvas.height);

    var foto = context.canvas.toDataURL();

    canvas = null;
    context = null;

    return foto;

}

subirFoto(params){
  console.log(params);
  const url = `${environment.URL_SERVICIOS}/document_shots?`;

  return this.http.post( url, params ).pipe(
              map( (resp: any) => {
                // console.log(resp);
                return resp //this.crearArreglosimul(resp);
              }));
}

updateShot( ids, params ) {

  const url = `${environment.URL_SERVICIOS}/document_shots/${ids}`;

  return this.http.patch( url, params ).pipe(
    map( (resp: any) => { return resp;
    } ));

}




}
